/**
 * AddReminderCtrl controller
 * Add/edit reminder
 */

import { REMINDER_TYPE } from 'app/core/constants'

/**
 * AddReminderCtrl controller
 *
 * @class AddReminderCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:AddReminderCtrl
 */
/* @ngInject */
export default function AddReminderCtrl ($uibModalInstance, announcement) {
  var vm = this

  /**
   * Reminder types
   *
   * @memberof mwApp/packages.controller:AddReminderCtrl
   * @type {Object}
   */
  vm.reminder_type = REMINDER_TYPE

  /**
   * Announcement
   *
   * @memberof mwApp/packages.controller:AddReminderCtrl
   * @type {models.Announcement}
   */
  vm.announcement = announcement

  /**
   * isNew flag
   *
   * @memberof mwApp/packages.controller:AddReminderCtrl
   * @type {Boolean}
   */
  vm.isNew = announcement._isNew()

  /**
   * Create or edit announcement, and close modal window afterwards
   *
   * @memberof mwApp/packages.controller:AddReminderCtrl
   */
  vm.submit = function () {
    vm.setDisable()
    announcement._save(null, null, announcement.name + ' Reminder has been added')
      .then(() => $uibModalInstance.close(announcement))
      .finally(vm.unsetDisable)
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/packages.controller:AddReminderCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
